import { Link } from 'react-router-dom'
import { FOOTER_LINKS, SOCIAL_LINKS } from '@/data/siteData'
import styles from './Footer.module.css'

const isInternal = (href) => href.startsWith('/')

// Minimal inline outline icons — no icon library is installed in this app,
// and pulling one in just for four footer glyphs isn't worth the dependency.
const SOCIAL_ICONS = {
  Instagram: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
    </svg>
  ),
  LinkedIn: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="7.5" y1="10" x2="7.5" y2="17" />
      <circle cx="7.5" cy="6.8" r="0.9" fill="currentColor" stroke="none" />
      <path d="M11.5 17v-4.2c0-1.6 1-2.6 2.4-2.6 1.4 0 2.1 1 2.1 2.6V17" />
      <line x1="11.5" y1="10" x2="11.5" y2="17" />
    </svg>
  ),
  Facebook: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16">
      <path d="M15 3h-2.2C10.7 3 9.5 4.3 9.5 6.5V9H7v3.2h2.5V21h3.2v-8.8H15l.5-3.2h-2.8V6.8c0-.8.4-1.3 1.3-1.3H15V3z" />
    </svg>
  ),
  YouTube: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16">
      <rect x="2.5" y="6" width="19" height="12" rx="3.5" />
      <path d="M10.5 9.5l5 2.5-5 2.5z" fill="currentColor" stroke="none" />
    </svg>
  ),
}

export default function Footer() {
  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.inner}>
        {/* Brand */}
        <div className={styles.brand}>
          <div className={styles.logo}>
            <img src="/nexusai-logo.png" alt="NexusAI" className={styles.logoImg} />
          </div>
          <p className={styles.copy}>
            © 2026 TechIntelliVerse Private Limited. All rights reserved.{' '}
            <a href="https://nexusaiweb.com" className={styles.link}>nexusaiweb.com</a>
          </p>
        </div>

        {/* Nav */}
        <nav aria-label="Footer navigation">
          <ul className={styles.links}>
            {FOOTER_LINKS.map(({ label, href }) => (
              <li key={label}>
                {isInternal(href) ? (
                  <Link to={href} className={styles.footerLink}>{label}</Link>
                ) : (
                  <a href={href} className={styles.footerLink}>{label}</a>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Social */}
        <div className={styles.social}>
          {SOCIAL_LINKS.map(({ label, href }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className={styles.socialLink}>
              {SOCIAL_ICONS[label]}
            </a>
          ))}
        </div>
      </div>

      {/* Sub-footer */}
      <div className={styles.sub}>
        <p>Part of the NexusAIWeb Ecosystem &nbsp;·&nbsp;
          <a href="/skillnexus"  className={styles.linkSub}>SkillNexus</a> &nbsp;·&nbsp;
          <a href="/internnexus" className={styles.linkSub}>InternNexus</a> &nbsp;·&nbsp;
          <a href="/promptnexus" className={styles.linkSub}>PromptNexus</a>
        </p>
      </div>
    </footer>
  )
}
